import Image from 'next/image';

import { Link } from '~/components/common/link';
import { formatContentfulDate } from '~/lib/contentful-date';
import { BlogTeaserFragment } from '~/server/generated/contentful-graphql';

import { SkeletonText } from '../ui/skeletons';
import { BlogCategory } from './blog-category';

interface BlogPostTeaserProps {
  post: BlogTeaserFragment;
  hideCategory?: boolean;
}

export function BlogPostTeaserSkeleton() {
  return (
    <article className='animate-pulse '>
      <div className='opacity-50'>
        <div className='bg-asphalt-50 aspect-3/2 w-full rounded-2xl' />
        <div className='mt-2.5'>
          <SkeletonText className='before:bg-asphalt-50 rounded-full' />
          <SkeletonText className='before:bg-asphalt-50 w-5/6 rounded-full' />
          <SkeletonText className='before:bg-asphalt-50 w-3/4 rounded-full' />
        </div>
      </div>
    </article>
  );
}

export function BlogPostTeaser({ post, hideCategory }: BlogPostTeaserProps) {
  return (
    <article>
      <Link className='text-black' href={`/stories/${post.slug}`}>
        {post.image?.url && (
          <Image
            alt={post.image.title ?? ''}
            src={post.image.url}
            width={600}
            height={400}
            className='aspect-3/2 mb-2.5 rounded-2xl object-cover'
          />
        )}
        <div>
          <h3 className='title-sm'>{post.title}</h3>
          <div className='body-sm mt-1.5 flex items-center gap-x-3'>
            {post.categories?.items?.[0] && !hideCategory && (
              <>
                <BlogCategory category={post.categories.items[0]} />
                <span className='text-muted-foreground'>&middot;</span>
              </>
            )}

            <time
              className='text-muted-foreground'
              dateTime={formatContentfulDate(post?.date, 'LLL do,yyyy')}
            >
              {formatContentfulDate(post?.date, 'LLL do, yyyy')}
            </time>
          </div>
        </div>
      </Link>
    </article>
  );
}
